import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogTrigger,
    } from '@/components/ui/alert-dialog';
    import { useForm } from '@inertiajs/vue3';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { Task } from '@/types';
    import { Button } from '@/components/ui/button';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteTask',
  props: {
    task: {}
  },
  emits: ['deleted'],
  setup(__props: any, { emit: __emit }) {

    const { t } = useI18n();

    const props = __props;

    const emit = __emit;

    const form = useForm({
        task_id: props.task.task_id,
    });

    const deleteTask = () => {
        form.post(route('v2.dashboard.tasks.delete'), {
            preserveScroll: true,
            onSuccess: () => {
                toast.success(t('dashboards.tasks_delete_success'));
                emit('deleted');
            },
            onError: (error) => {
                toast.error(t('forms.general.error'));
            },
        });
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "link_destructive",
            size: "none",
            class: "mr-auto"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('dashboards.tasks_delete')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('dashboards.tasks_delete')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('dashboards.tasks_delete_confirm')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('users.js.no')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                onClick: deleteTask,
                variant: "destructive"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('users.js.yes')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})